import { render, staticRenderFns } from "./BitQGaming.vue?vue&type=template&id=bbf37700&scoped=true"
import script from "./BitQGaming.vue?vue&type=script&lang=js"
export * from "./BitQGaming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf37700",
  null
  
)

export default component.exports